<template>
  <div v-link="{ path: `/orders/${order.id}` }" :class="status_classes">
    <table class="table">
      <tbody>
        <tr>
          <td class="nearby">
            <i
              class="icon marker geolocation-marker"
              :class="{ active: nearby }"
            ></i>
            <i
              class="icon marker printer-marker"
              :class="{ active: label_printed }"
            ></i>
          </td>
          <td class="pickup-at">
            {{ order.pickup_at | date-format 'time' }}<br />
            <small
              class="text-nowrap"
              >{{ order.pickup_at | date-format 'date' }}</small
            >
          </td>
          <td class="order-number">{{ order.number }}</td>
          <td class="customer-name">
            <order-icon-image :order="order"></order-icon-image>
            {{ customer.first_name }}
            {{ last_name }}
          </td>
          <td class="items">{{ processed_item_count }} of {{ item_count }}</td>
          <td class="total-price">{{ subtotal | currency }}</td>
          <td class="total-weight">
            {{ weight | fractional }}
            {{ 'pound' | unit-of-measure weight true }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DescribesAnOrder from 'mixins/DescribesAnOrder';
import OrderIconImage from './OrderIconImage';

export default {
  mixins: [DescribesAnOrder],

  props: ['order'],

  components: {
    OrderIconImage,
  },
};
</script>



// WEBPACK FOOTER //
// Order.vue?250f77ac